<template>
  <div class="container my-4">
    <div class="bg-transparent rounded-4 border-0">
      <div class="card-body">

        <h3 class="mb-4 text-primary fw-bold">Payment History</h3>

        <!-- Filter Section -->
        <div class="row row-cols-1 row-cols-md-3 g-3 mb-4">
          <div class="col">
            <label for="teacher" class="form-label">Teacher</label>
            <select v-model="selectedTeacher" class="form-select" id="teacher">
              <option value="">All Teachers</option>
              <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
                {{ teacher.user.first_name }}
              </option>
            </select>
          </div>

          <div class="col">
            <label class="form-label">Subject</label>
            <select v-model="selectedSubject" class="form-select">
              <option value="">All Subjects</option>
              <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
                {{ subject.name }}
              </option>
            </select>
          </div>

          <div class="col">
            <label class="form-label">Date Filter</label>
            <select v-model="selectedDateFilter" class="form-select">
              <option value="all">All Dates</option>
              <option value="last">Last Payment</option>
              <option value="today">Today</option>
              <option value="last_week">Last Week</option>
              <option value="last_month">Last Month</option>
              <option disabled>──────────</option>
              <option v-for="month in last12Months" :key="month.value" :value="month.value">
                {{ month.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Loader -->
        <div v-if="loading" class="d-flex justify-content-center align-items-center my-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No Payments -->
        <div v-else-if="payments.length === 0" class="alert alert-warning text-center fw-medium">
          No payment history found.
        </div>

        <!-- Payment Table -->
        <div v-else class="table-responsive">
          <table class="table table-hover table-bordered align-middle shadow-sm">
            <thead class="table-light">
              <tr>
                <th>Teacher</th>
                <th>Subject</th>
                <th>Total Paid</th>
                <th>Last Payment</th>
                <th>Status</th>
                <th>History</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in payments" :key="payment.id">
                <td class="tdClass" data-label="Teacher Name">{{ payment.teacher?.user.first_name || 'N/A' }} {{ payment.teacher?.user.last_name || 'N/A' }}</td>
                <td class="tdClass" data-label="Subject">{{ payment.subject?.name || 'N/A' }}</td>
                <td class="tdClass" data-label="Total Paid">Rs. {{ payment.total_paid_amount }}</td>
                <td class="tdClass" data-label="Last Payment">{{ payment.last_payment_date }}</td>
                <td class="tdClass" data-label="Payment Status">
                  <span class="badge bg-success" v-if="payment.payment_status === 'Paid'">Paid</span>
                  <span class="badge bg-danger" v-else>Pending</span>
                </td>
                <td>
                  <!-- <ul class="list-unstyled mb-0">
                    <li v-for="entry in payment.payment_histories" :key="entry.id">
                      {{ entry.payment_date }} - Rs. {{ entry.paid_amount }} via {{ entry.payment_method || 'N/A' }}
                    </li>
                  </ul> -->

                  <button 
          class="btn btn-primary btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#paymentHistoryModal"
          @click="openHistory(payment)"
        >
          Show
        </button>
                </td>
              </tr>
            </tbody>
          </table>


          <!-- Payment History Modal -->
<div class="modal fade" id="paymentHistoryModal" tabindex="-1" aria-labelledby="paymentHistoryLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="paymentHistoryLabel">
          Payment History - {{ selectedPayment.teacher?.user.first_name || '' }} {{ selectedPayment.teacher?.user.last_name || '' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Method</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in selectedPayment.payment_histories" :key="entry.id">
              <td data-label="Payment Date">{{ entry.payment_date }}</td>
              <td data-label="Paid Amount">Rs. {{ entry.paid_amount }}</td>
              <td data-label="Payment Method">{{ entry.payment_method || 'N/A' }}</td>
            </tr>
            <tr v-if="!selectedPayment.payment_histories || selectedPayment.payment_histories.length === 0">
              <td colspan="3" class="text-center text-muted">No payment history available.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>




        </div>

        <!-- Pagination -->
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
          <button class="btn btn-outline-primary" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
            Previous
          </button>
          <span class="fw-semibold">Page {{ currentPage }} of {{ lastPage }}</span>
          <button class="btn btn-outline-primary" @click="goToPage(currentPage + 1)" :disabled="currentPage === lastPage">
            Next
          </button>
        </div>

      </div>
    </div>

  </div>
</template>


  
<script>
import axios from 'axios';

export default {
  data() {
    return {
      payments: [],
      selectedPayment: {}, // store payment clicked
      loading: true,

      teachers: [],
        selectedTeacher: '',

        selectedSubject: "",
        subjects: [],
        selectedDateFilter: 'all',
        last12Months: [], // ✅ Add this
        currentPage: 1, // 🔹 Track current page
    lastPage: 1,    // 🔹 Total pages from backend
    };
  },

  watch: {
  selectedTeacher() {
    this.fetchSubjects();          // <- load subjects for selected teacher
    this.fetchPaymentHistory();    // <- load payment history based on teacher
  },
  selectedSubject() {
    this.fetchPaymentHistory();
  },
  selectedDateFilter() {
    this.fetchPaymentHistory();
},

},



  methods: {
     // 🔹 Pagination handlers
  goToPage(page) {
    if (page >= 1 && page <= this.lastPage) {
      this.currentPage = page;
      this.fetchPaymentHistory();
    }
  },
  openHistory(payment) {
      this.selectedPayment = payment;
    },

    generateLast12Months() {
    const months = [];
    const currentDate = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      months.push({ 
        label: `${year} ${month}`, 
        value: `${year}-${String(date.getMonth() + 1).padStart(2, '0')}` 
      });
    }
    this.last12Months = months;
  },

    fetchPaymentHistory() {
  const instituteId = localStorage.getItem('institute_id');
  this.loading = true; // <- set this early

  if (!instituteId) {
    console.error('Institute ID not found in localStorage');
    this.loading = false;
    return;
  }

  axios
    .get('/institute-payment-history', {
      headers: {
        'institute-id': instituteId,
      },
      params: {
        teacher_id: this.selectedTeacher || undefined,
        subject_id: this.selectedSubject || undefined,
        date_filter: this.selectedDateFilter !== 'all' ? this.selectedDateFilter : undefined,
        page: this.currentPage,
      },
    })
    .then((response) => {
    //   this.payments = response.data;
      this.payments = response.data.data;     // Data
      this.lastPage = response.data.last_page; // Update last page
    })
    .catch((error) => {
      console.error('Error fetching payment history:', error);
    })
    .finally(() => {
      this.loading = false;
    });
},


    fetchTeachers() {
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-teachers-by-institute', {
          params: { institute_id: instituteId }
        })
        .then(response => {
          this.teachers = response.data;
        })
        .catch(error => {
          console.error('Error fetching teachers:', error);
        });
      },
      async fetchSubjects() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-subjects", {
          teacher_id: teacherId,
        });
        this.subjects = response.data;
      } catch (error) {
        console.error("Failed to fetch subjects:", error);
      }
    },
  },
  


  

    mounted() {
    this.fetchPaymentHistory();
    this.fetchTeachers();
      this.fetchSubjects();
      this.generateLast12Months();
  },
  
};
</script>
  

<style scoped lang="scss">
.container {

  z-index: 0;
  max-width: 1200px;
  padding: 0 15px;
  height: 100dvh;
}

.card {
  position:inherit;
  z-index: 0;
  background-color: #fefefe;
}

.table {
  font-size: 0.95rem;
  th, td {
    vertical-align: middle;
  }
}

@media (max-width: 769px) {

  .container {
  max-width: 300px;
  padding: 0 0px;
}
  .table thead {
    display: none;
  }


  .table tbody tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    // padding: 1rem;
    padding: 1rem;   /* ✅ space inside card */
    background: #fff; /* optional for card look */
  }

  .table td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border: none;
  }

  .table td::before {
    font-weight: 600;
    color: #6c757d;
    content: attr(data-label);
  }
}
</style>
